import {Injectable} from "@angular/core";
import {DxUserSession} from "../../../domain/user/dx-user-session";
import {Observable} from "rxjs";
import {DxSessionRefreshStrategy} from "./dx-session-refresh-strategy";
import {fromPromise} from "rxjs/internal-compatibility";
import {DxHttpDispatcher} from "../../../../dx-core/services/dx-http-dispatcher.service";
import {DxConfigService} from "../../../../dx-core/services/dx-config.service";
import {DxEncryptionService} from "../../../../dx-core/services/dx-encryption.service";
import {DxKeycloakAuthenticationStrategy} from "../auth/dx-keycloak-authentication-strategy";
import {HttpHeaders} from "@angular/common/http";
import {DxEncryptionStrategyType} from "../../../../dx-core/config/dx-encryptions-type";
import {DxKeycloakUtils} from "../../utils/dx-keycloak-utils";
import {DxSessionRefreshResult} from "../../../domain/user/dx-session-refresh-result";
import {DxOperationResultType} from "../../../../dx-core/domain/common/dx-operation-result-type";
import {PitActivityGridRow} from "../../../../pit-activities/domain/pit-activity-grid-row";
import {DxObjectMapper} from "../../../../dx-core/services/dx-object-mapper.service";
import {BdpkConfigService} from "../../../../bdpk-common/services/bdpk-config.service";

/**
 * Стратегия обновления сессии при использовании keycloak
 */
@Injectable()
export class DxServerDefinedSessionRefreshStrategy implements DxSessionRefreshStrategy {

  constructor(private _http: DxHttpDispatcher,
              private _configService: BdpkConfigService,
              private _mapper: DxObjectMapper) {
  }

  public refreshSession(session: DxUserSession): Observable<DxSessionRefreshResult> {
    const promise = new Promise<DxSessionRefreshResult>((resolve) => {
      const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

      const result: DxSessionRefreshResult = new DxSessionRefreshResult();
      this._http.get(this._configService.pitSessionStorageService + '/acl/session',
                     {headers: headers, observe: 'response', withCredentials: true })
                .subscribe(response => {
                    const ses: DxUserSession = this._mapper.deserialize<DxUserSession>(response.body, DxUserSession);
                    for (const attr in ses) {
                      session[attr] = ses[attr];
                    }
                    result.type = DxOperationResultType.SUCCESS;
                    resolve(result);

                  }, errorResponse => {
                    result.type = DxOperationResultType.FAILED;
                    result.error = DxHttpDispatcher.handleHttpError(errorResponse);
                    resolve(result);
                  });
                });
    return fromPromise<DxSessionRefreshResult>(promise);
  }
}
